import React from 'react'

export const IcoCompetitorGap = ({ style = {} }) => {
  const iconStyle = {
    display: 'inline-block',
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    color: '#ff00ff',
    transform: 'translateY(4px) scale(1.25)',
    ...style
  }

  const pathStyle = {
    fill: 'none',
    stroke: '#ff00ff',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    vectorEffect: 'non-scaling-stroke'
  }

  return (
    <svg
      className='icon-competitor-gap'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      style={iconStyle}
    >
      <path
        style={pathStyle}
        d='M7.5 17V6'
      />

      <path
        style={pathStyle}
        d='M4.5 9L7.5 6L10.5 9'
      />

      <path
        style={pathStyle}
        d='M16.5 7v11'
      />

      <path
        style={pathStyle}
        d='M13.5 15L16.5 18L19.5 15'
      />
    </svg>
  )
}